import { useContext } from 'react';
import { useNavigation } from './NavigationHandler';
import { AppContext } from '../DataProviders/AppStateProvider';

/**
 * Counter Handler
 *
 * Helps to track the current steps in the view, except the intro and result steps.
 *
 * @returns {{counterCurrent: number, counterTotal: number}}
 */
export const useCounter = () => {
  const { appData } = useContext(AppContext);
  const { findIndexByKey } = useNavigation();

  const counterTotal = Object.keys(appData.journeys[appData.currentJourney]).length - 1;
  const counterCurrent = Math.min(findIndexByKey(appData.currentStep) + 1, counterTotal);

  return {
    counterCurrent,
    counterTotal
  };
};
